import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import elZhCn from 'element-plus/lib/locale/lang/zh-cn';
import elEn from 'element-plus/lib/locale/lang/en';
import elVi from 'element-plus/lib/locale/lang/vi';
export const languages = {
  'zh-cn': {
    label: '简体中文',
    value: 'zh-cn',
    relation: ['zh-cn', 'zh-CN', 'ZH-CN'],
    elLocale: 'zh-cn',
    message: async () => (await import('@/lang/modules/zh-cn')).default,
    elMessage: elZhCn
  },
  en: {
    label: 'English',
    value: 'en',
    relation: ['en-us', 'en', 'en-US'],
    elLocale: 'en',
    message: async () => (await import('@/lang/modules/en')).default,
    elMessage: elEn
  },
  vi: {
    label: 'Tiếng Việt',
    value: 'vi',
    relation: ['vi-vn', 'vi', 'vi-VN'],
    elLocale: 'vi',
    message: () => import('@/lang/modules/vi').then(mod => mod.default),
    elMessage: elVi
  }
};
export const langList = Object.values(languages);
export const defaultLanguage = langList[0].value;
export const getLocale = () => {
  const navLang = localStorage.getItem('lang') || navigator.language || navigator.userLanguage || defaultLanguage;
  const value = getActualLanguage(navLang);
  return value;
};
export function getActualLanguage(lang) {
  return Object.values(languages).find(item => item.relation.includes(lang))?.value || defaultLanguage;
}